module.exports = __webpack_public_path__ + "img/support.8b01e9d1.png";